export enum LanguageCodes {
  English = 'E',
  Arabic = 'A',
}

export enum Languages {
  E = 'English',
  A = 'Arabic',
}

export const languageLabels = [Languages.A, Languages.E];
